import React from "react"
interface WhiteBoxProps {
	className?: string
}
const WhiteBox: React.FC<WhiteBoxProps> = ({ children, className }) => {
	return <div className={`white-box ${className}`}>{children}</div>
}

export default WhiteBox
